import { gsap } from 'gsap'
import Swiper from 'swiper'
import { Navigation, EffectFade, Pagination } from 'swiper/modules'


//
// let textSwiper = new Swiper('.swiper-text-slider', {
//   modules: [Navigation, EffectFade, Pagination],
//   effect: 'fade',
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-text-slider-navigation .slide-next',
//     prevEl: '.swiper-text-slider-navigation .slide-prev'
//   },
//   pagination: {
//     el: '.text-slide-pagination',
//     type: 'fraction'
//   }
// })
//
// textSwiper.on('beforeSlideChangeStart', function () {
//   $('.swiper-text').css('opacity', 0)
// })
//
// textSwiper.on('slideChange', function () {
//   gsap.fromTo('.swiper-text', { opacity: 0 }, { opacity: 1, duration: 1.5})
// })

const textSwipers = document.querySelectorAll('.text-slider')

textSwipers.forEach(txtSwiper => {
  const swiper = txtSwiper.querySelector('.swiper-text-slider')
  const slideNext = txtSwiper.querySelector('.slide-next')
  const slidePrev = txtSwiper.querySelector('.slide-prev')
  const paginationEl = txtSwiper.querySelector('.text-slide-pagination')
  const text = txtSwiper.querySelectorAll('.swiper-text')

  let textSwiper = new Swiper(swiper, {
    modules: [Navigation, EffectFade, Pagination],
    effect: 'fade',
    loop: true,
    navigation: {
      nextEl: slideNext,
      prevEl: slidePrev
    },
    pagination: {
      el: paginationEl,
      type: 'fraction'
    }
  })



  textSwiper.on('beforeSlideChangeStart', function () {
    gsap.set(text, { opacity: 0})
  })

  textSwiper.on('slideChange', function () {
    gsap.fromTo(text, { opacity: 0 }, { opacity: 1, duration: 1.5})
  })

})
